import { render, staticRenderFns } from "./FileSts.vue?vue&type=template&id=3750fd72&scoped=true&"
import script from "./FileSts.vue?vue&type=script&lang=js&"
export * from "./FileSts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3750fd72",
  null
  
)

export default component.exports